module.exports = __webpack_public_path__ + "img/peak-logo.1c3c5024.svg";